<device-info-card>
  <!-- Card: Identidad -->
  <div class="card h-100">
    <div class="card-header bg-white">
      <span class="fw-semibold">Identidad</span>
    </div>
    <div class="card-body">
      <!-- View mode -->
      <div if={ !state.editMode }>
        <div class="d-flex flex-wrap gap-1 mb-3">
          <span class="badge text-bg-light border fw-normal">{ props.device.city }</span>
          <span class="badge text-bg-light border fw-normal">{ props.device.app }</span>
          <span if={ props.device.tagid } class="badge text-bg-light border fw-normal">NFC activo</span>
        </div>

        <div class="dd-id-row">
          <span class="dd-id-key">ID</span>
          <span class="dd-id-val dd-copyable" onclick={ () => copyToClipboard(props.device._id, 'ID copiado') } title="Copiar ID">{ props.device._id }</span>
        </div>
        <div class="dd-id-row">
          <span class="dd-id-key">Chip ID</span>
          <span class="dd-id-val dd-copyable" if={ props.device.details && props.device.details.chipId } onclick={ () => copyToClipboard(props.device.details.chipId, 'Chip ID copiado') } title="Copiar Chip ID">{ props.device.details.chipId }</span>
          <span class="dd-id-val text-muted" if={ !props.device.details || !props.device.details.chipId }>—</span>
        </div>
        <div class="dd-id-row">
          <span class="dd-id-key">Firmware</span>
          <span class="dd-id-val">{ getFirmware() }</span>
        </div>
        <div class="dd-id-row">
          <span class="dd-id-key">IP</span>
          <span class="dd-id-val dd-copyable" if={ props.device.details && props.device.details.ip } onclick={ () => copyToClipboard(props.device.details.ip, 'IP copiada') } title="Copiar IP">{ props.device.details.ip }</span>
          <span class="dd-id-val text-muted" if={ !props.device.details || !props.device.details.ip }>—</span>
        </div>
        <div class="dd-id-row">
          <span class="dd-id-key">Conexión</span>
          <span class="dd-id-val plain" title={ props.device.lastConnection ? formatDate(props.device.lastConnection) : '' }>
            <span if={ props.isonline } class="badge bg-success-subtle text-success border border-success-subtle fw-normal">
              Online · { props.elapsedseconds }s
            </span>
            <span if={ !props.isonline && props.device.lastConnection } class="text-muted">{ formatLastConnection() }</span>
            <span if={ !props.isonline && !props.device.lastConnection } class="text-muted">Nunca</span>
          </span>
        </div>
        <div class="dd-id-row">
          <span class="dd-id-key">Tag NFC</span>
          <span class="dd-id-val { props.device.tagid ? 'dd-copyable' : 'text-muted' }" onclick={ () => props.device.tagid && copyToClipboard(props.device.tagid, 'Tag ID copiado') } title={ props.device.tagid ? 'Copiar Tag ID' : '' }>{ props.device.tagid || '—' }</span>
        </div>
        <div class="dd-id-row">
          <span class="dd-id-key">Nombre visible</span>
          <span class="dd-id-val plain">{ props.device.name }</span>
        </div>

        <div if={ hasEditPermission() } class="pt-3">
          <button class="btn btn-primary w-100" onclick={ toggleEditMode }>
            <i class="bi bi-pencil me-1"></i> Edición rápida
          </button>
        </div>
      </div>
      <!-- Edit mode form -->
      <form if={ state.editMode } onsubmit={ handleSaveChanges } novalidate>
        <div class="mb-3">
          <label for="deviceName" class="form-label">Nombre <span class="text-danger">*</span></label>
          <input type="text" class="form-control { state.errors['name'] ? 'is-invalid' : '' }" id="deviceName" name="name" value={ state.editData.name } oninput={
            handleEditInput } />
          <div class="invalid-feedback" if={ state.errors['name'] }>{ state.errors['name'] }</div>
        </div>
        <div class="mb-3">
          <label for="deviceTagid" class="form-label">Tag NFC</label>
          <input type="text" class="form-control" id="deviceTagid" name="tagid" value={ state.editData.tagid } oninput={
            handleEditInput } placeholder="Identificador de tarjeta NFC (opcional)" />
          <div class="form-text">Deja vacío para eliminar o no asignar tag NFC</div>
        </div>
        <div class="mb-3">
          <label for="deviceCity" class="form-label">Ciudad <span class="text-danger">*</span></label>
          <input type="text" class="form-control { state.errors['city'] ? 'is-invalid' : '' }" id="deviceCity" name="city" value={ state.editData.city } oninput={
            handleEditInput } />
          <div class="invalid-feedback" if={ state.errors['city'] }>{ state.errors['city'] }</div>
        </div>
        <div class="mt-4">
          <button type="submit" class="btn btn-primary me-2" disabled={ state.saving }>
            <i class="bi bi-check me-1"></i> { state.saving ? 'Guardando...' : 'Guardar cambios' }
          </button>
          <button type="button" class="btn btn-outline-secondary" onclick={ toggleEditMode } disabled={ state.saving }>
            Cancelar
          </button>
        </div>
      </form>
    </div>
  </div>



  <script>
    import { DeviceService } from '../services';
    import { ToastService } from '../services/toast-service';
    import { formatDate } from '../utils/device-utils';

    export default {
      onBeforeMount() {
        this.state = {
          editMode: false,
          editData: {
            name: '',
            tagid: '',
            city: ''
          },
          errors: {},
          saving: false
        };
      },

      hasEditPermission() {
        return this.props.isadmin || (
          this.props.user &&
          this.props.device &&
          this.props.device.user === this.props.user._id
        );
      },

      formatDate(timestamp) {
        return formatDate(timestamp);
      },

      getFirmware() {
        const details = this.props.device && this.props.device.details;
        if (!details || !details.fw_name) return '—';
        return details.fw ? `${details.fw_name} (${details.fw})` : details.fw_name;
      },

      formatLastConnection() {
        if (!this.props.device || !this.props.device.lastConnection) return 'Nunca';

        const lastConnection = new Date(this.props.device.lastConnection);
        const now = new Date();

        const diffMs = now.getTime() - lastConnection.getTime();
        const diffSec = Math.floor(diffMs / 1000);
        const diffMin = Math.floor(diffSec / 60);
        const diffHour = Math.floor(diffMin / 60);
        const diffDays = Math.floor(diffHour / 24);

        if (diffSec < 60) {
          return 'Hace unos segundos';
        } else if (diffMin < 60) {
          return `Hace ${diffMin} ${diffMin === 1 ? 'minuto' : 'minutos'}`;
        } else if (diffHour < 24) {
          return `Hace ${diffHour} ${diffHour === 1 ? 'hora' : 'horas'}`;
        } else {
          return `Hace ${diffDays} ${diffDays === 1 ? 'día' : 'días'}`;
        }
      },

      toggleEditMode() {
        const newEditMode = !this.state.editMode;

        if (newEditMode && this.props.device) {
          this.update({
            editMode: newEditMode,
            errors: {},
            editData: {
              name: this.props.device.name,
              tagid: this.props.device.tagid || '',
              city: this.props.device.city
            }
          });
        } else {
          this.update({ editMode: newEditMode, errors: {} });
        }
      },

      handleEditInput(e) {
        const { name, value } = e.target;
        const newEditData = { ...this.state.editData };
        newEditData[name] = value;
        this.update({ errors: this.clearError(name), editData: newEditData });
      },

      // Devuelve una copia de los errores sin el campo indicado, para que la
      // marca de error desaparezca apenas el usuario corrige el dato
      clearError(name) {
        if (!this.state.errors || !this.state.errors[name]) {
          return this.state.errors;
        }

        const errors = { ...this.state.errors };
        delete errors[name];
        return errors;
      },

      validateForm() {
        const { name, city } = this.state.editData;
        const errors = {};

        if (!name || !name.trim()) {
          errors.name = 'El nombre es requerido';
        }

        if (!city || !city.trim()) {
          errors.city = 'La ciudad es requerida';
        }

        this.update({ errors });

        if (Object.keys(errors).length > 0) {
          this.showToast('Revisá los campos marcados en rojo', 'warning');
          return false;
        }

        return true;
      },

      async handleSaveChanges(e) {
        e.preventDefault();
        if (!this.validateForm()) {
          return;
        }
        this.update({ saving: true });

        try {
          const updatedDevice = await DeviceService.updateDevice(
            this.props.device._id,
            this.state.editData
          );

          this.update({
            saving: false,
            editMode: false
          });

          this.showToast('Dispositivo actualizado correctamente', 'success');

          if (this.props.ondeviceupdated) {
            this.props.ondeviceupdated(updatedDevice);
          }
        } catch (error) {
          console.error('Error updating device:', error);
          this.showToast('Error al actualizar el dispositivo: ' + (error.message || 'Error desconocido'), 'danger');
          this.update({ saving: false });
        }
      },

      showToast(message, type = 'primary') {
        ToastService.show(message, type);
      },

      async copyToClipboard(text, toastMessage = 'Copiado') {
        try {
          if (!text) return;
          const nav = typeof navigator !== 'undefined' ? navigator : null;
          if (nav && nav.clipboard && typeof nav.clipboard.writeText === 'function') {
            await nav.clipboard.writeText(String(text));
            this.showToast(toastMessage, 'success');
          }
        } catch (err) {
          console.error('Clipboard error:', err);
          this.showToast('No se pudo copiar', 'danger');
        }
      }
    }
  </script>

</device-info-card>